import React, { useEffect } from 'react';
import { CONFIG } from '../../../config';
import './AmazonConsentWidget.scss';

type Props = {
  billingAgreementId?: string;
  onChange?: (checked: boolean) => void;
};

type AmazonConsent = {
  getConsentStatus: () => 'true' | 'false';
};

const CONTAINER_ID = 'amazonConsentWidget';

const renderWidget = (billingAgreementId?: string, onChange?: Props['onChange']) => {
  new window.OffAmazonPayments.Widgets.Consent({
    sellerId: CONFIG.AMAZON_SELLER_ID,
    amazonBillingAgreementId: billingAgreementId,
    onReady: ({ getConsentStatus }: AmazonConsent) => onChange?.(getConsentStatus() === 'true'),
    onConsent: ({ getConsentStatus }: AmazonConsent) => onChange?.(getConsentStatus() === 'true'),
    design: {
      designMode: 'responsive'
    }
  }).bind(CONTAINER_ID);
};

export const AmazonConsentWidget: React.FC<Props> = ({ billingAgreementId, onChange }) => {
  useEffect(() => {
    renderWidget(billingAgreementId, onChange);
  }, [billingAgreementId, onChange]);

  return <div id={CONTAINER_ID} className="AmazonConsentWidget" />;
};
